module.exports = __webpack_public_path__ + "static/media/notification-icon-bullhorn.885e8180.svg";